import { Link } from "react-router-dom";
import { NAV } from "@/constants/testIds";
import { useLang } from "@/context/LangContext";

export function MatproLogo({ variant = "default", size = "md", alwaysShowWordmark = false }) {
  const { t } = useLang();
  const textSize =
    size === "lg"
      ? "text-2xl sm:text-3xl"
      : size === "sm"
        ? "text-base sm:text-lg"
        : "text-lg sm:text-2xl";
  const markSize =
    size === "lg"
      ? "h-10 w-10 sm:h-11 sm:w-11"
      : size === "sm"
        ? "h-8 w-8"
        : "h-9 w-9 sm:h-10 sm:w-10";
  const isLight = variant === "light";

  return (
    <Link
      to="/"
      data-testid={NAV.logo}
      aria-label={t("nav.logo_home")}
      className="group flex min-w-0 max-w-[min(100%,14rem)] items-center gap-2 select-none sm:max-w-none sm:gap-2.5"
    >
      <img
        src="/brand/matpass-mark.png"
        alt=""
        aria-hidden
        className={`${markSize} shrink-0 rounded-md object-contain ${isLight ? "bg-white" : ""}`}
      />
      <div className={`min-w-0 truncate font-heading font-black leading-none tracking-tight ${textSize}`}>
        <span className={isLight ? "text-white" : "text-matpro-anthracite"}>MAT</span>
        <span className="text-matpro-green">PASS</span>
      </div>
    </Link>
  );
}

/**
 * Full brand lockup (mark + wordmark + tagline) used for hero / auth pages.
 * Renders the official artwork straight from /public/brand.
 */
export function MatproLogoFull({ className = "", variant = "default" }) {
  const bg = variant === "light" ? "bg-white" : "";
  return (
    <div className={`inline-flex items-center justify-center ${bg} rounded-md ${className}`}>
      <img
        src="/brand/matpro-logo.png"
        alt="MATPASS · Achat · Revente · Matériel"
        className="max-w-full h-auto"
      />
    </div>
  );
}
